import { isStaffUser } from "@arcteryx/js-auth";

const marketBaseUrl = market => {
  switch (market) {
    case "outlet":
      return "outlet.arcteryx.com";
    case "outdoor":
    default:
      return "arcteryx.com";
  }
};

export const returnsLinks = (data, market) =>
  isStaffUser()
    ? ""
    : `
  <li>
    <a href="/account/returns" data-analyticsLabel="Returns and Refunds" data-linkid="footer:returnsandrefunds" data-url="${marketBaseUrl(
      market
    )}/account/returns" class="isLoggedIn isStaff">${data["Returns & Refunds"]}</a>
    <a href="/help/returns" data-analyticsLabel="Returns and Refunds" data-linkid="footer:returnsandrefunds" data-url="${marketBaseUrl(
      market
    )}/help/returns" class="notLoggedIn isStaff">${data["Returns & Refunds"]}</a>
  </li>
`;
